export const loadRazorpay = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) { resolve(true); return; }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const PLANS = {
  pro: {
    name: 'Pro Plan',
    amount: 99900, // in paise (₹999)
    description: 'TradeFix AI Pro - Monthly',
  },
  elite: {
    name: 'Elite Plan',
    amount: 199900, // ₹1999
    description: 'TradeFix AI Elite - Monthly',
  },
};

export const openRazorpay = async (planKey, user, onSuccess) => {
  const loaded = await loadRazorpay();
  if (!loaded) {
    alert('Payment gateway load nahi hua. Internet check karo.');
    return;
  }

  const plan = PLANS[planKey];

  const options = {
    key: process.env.REACT_APP_RAZORPAY_KEY,
    amount: plan.amount,
    currency: 'INR',
    name: 'TradeFix AI',
    description: plan.description,
    image: 'https://tradefixai.in/logo.png',
    handler: async (response) => {
      await onSuccess(response, planKey);
    },
    prefill: {
      name: user?.displayName || '',
      email: user?.email || '',
    },
    theme: {
      color: '#00d084',
    },
    modal: {
      ondismiss: () => {
        console.log('Payment cancelled');
      },
    },
  };

  const rzp = new window.Razorpay(options);
  rzp.on('payment.failed', (response) => {
    alert('Payment failed: ' + (response.error?.description || 'Please try again.'));
  });
  rzp.open();
};
